import React, { useState, useEffect, useRef } from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Button,
  TextField,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  FormControl,
  FormControlLabel,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  button_bg_color_for_New_Project,
  settingsModal_bg_color_dm,
} from "../../../../../constants/colors";
import { ToggleSwitch } from "../../../../Common_Components/ToggleSwitch";
import {
  AddVoiceAgentForCallingAgent,
  getLLMAgentForCalligAgent,
  getVoiceAgentLanguageForCallingAgent,
  getVoiceAgentPersonaForCallingAgent,
  getVoiceAgentPhoneNumberForCallingAgent,
  UpdateVoiceAgentbyIdForCallingAgent,
} from "../../../../../contexts/WorkspaceUtils";
import CommonToast from "../../../../Common_Components/CommonToast";
import { useWorkspace } from "../../../../../contexts/WorkspaceContext";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";

const ModalForVoiceAgent = ({
  openAddVoiceAgentModal,
  setopenAddVoiceAgentModal,
  HandleCloseButtonClick,
  fetchData,
  activeUserObject,
  setMoreActionOption,
}) => {
  const theme = localStorage.getItem("theme");
  const [toastopen, setToastopen] = useState(false);
  const [content, setContent] = useState("");
  const [iconType, setIconType] = useState("success");
  const [addVoiceAgent, setAddVoiceAgent] = useState({
    label: "",
    type: "web_call",
    language_id: 0,
    voice_persona_id: 0,
    ai_model_id: 0,
    tool_ids: [101, 102, 103],
    phone_number_id: 0,
    auto_detect_context: true,
  });
  const [loading, setLoading] = useState(false);
  const {
    voiceAgentsAllLanguage,
    setVoiceAgentsAllLanguage,
    voiceAgentsAllPhoneNumber,
    setVoiceAgentsAllPhoneNumber,
    voiceAgentsAllPersona,
    setVoiceAgentsAllPersona,
    voiceAgentAllAIAgent,
    setVoiceAgentAllAIAgent,
  } = useWorkspace();
   const [playingVoice, setPlayingVoice] = useState(null);
    const audioElement = useRef(null);

  useEffect(() => {
    if (activeUserObject) {
      setAddVoiceAgent((prev) => ({
        ...prev,
        label: activeUserObject?.label,
        type: activeUserObject?.type,
        language_id: activeUserObject?.language_id,
        voice_persona_id: activeUserObject?.voice_persona_id,
        ai_model_id: activeUserObject?.ai_model_id,
        tool_ids: [101, 102, 103],
        phone_number_id: activeUserObject?.phone_number_id,
        auto_detect_context: activeUserObject?.auto_detect_context || true,
      }));
    } else {
      setAddVoiceAgent({
        label: "",
        type: "web_call",
        language_id: 0,
        voice_persona_id: 0,
        ai_model_id: 0,
        tool_ids: [101, 102, 103],
        phone_number_id: 0,
        auto_detect_context: true,
      });
    }
  }, [
    activeUserObject,
    voiceAgentsAllLanguage,
    voiceAgentsAllPersona,
    voiceAgentsAllPhoneNumber,
  ]);

     useEffect(() => {
       return () => {
         if (audioElement.current) {
           audioElement.current.pause();
           audioElement.current.currentTime = 0;
           audioElement.current.src = "";
           audioElement.current = null;
         }
         setPlayingVoice(null);
       };
     }, [openAddVoiceAgentModal]);
   

  const customTextFieldStylesforDropDownButton = {
    "& .MuiInputLabel-root": {
      fontFamily: "Inter",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "24px",
      letterSpacing: "0.5px",
      color: "rgba(255, 255, 255, 0.80)",
      "&.Mui-focused": {
        color: "rgba(255, 255, 255, 0.80) !important",
      },
    },
    "& .MuiInputBase-input": {
      color: "#FFFFFF",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "rgba(255, 255, 255, 0.80)",
      },
      "&:hover fieldset": {
        borderColor: "rgba(255, 255, 255, 0.80)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "rgba(255, 255, 255, 0.80) !important",
      },
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiInputLabel-root": {
      color: "rgba(255, 255, 255, 0.80) !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(255, 255, 255, 0.80) !important",
    },
  };

  const customTextFieldStyles = (isInvalid) => {
    return {
      "& .MuiInputLabel-root": {
        fontFamily: "Inter",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "24px",
        letterSpacing: "0.5px",
        color: "rgba(255, 255, 255, 0.80)",
        "&.Mui-focused": {
          color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80)",
        },
      },
      "& .MuiInputBase-input": {
        color: "#FFFFFF",
      },
      "& #outlined-basic-label": {
        color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80)",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: isInvalid ? "#F2B8B5" : "rgba(255, 255, 255, 0.80)",
        },
        "&:hover fieldset": {
          borderColor: isInvalid ? "#F2B8B5" : "rgba(255, 255, 255, 0.80)",
        },
        "&.Mui-focused fieldset": {
          borderColor: isInvalid
            ? "#F2B8B5 !important"
            : "rgba(255, 255, 255, 0.80) ",
        },
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiInputLabel-root": {
        color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80) ",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: isInvalid
          ? "#F2B8B5 !important"
          : "rgba(255, 255, 255, 0.80) ",
      },
    };
  };

  const customTextFieldStylesForInvalid = () => {
    return {
      "& .MuiInputLabel-root": {
        fontFamily: "Inter",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "24px",
        letterSpacing: "0.5px",
        color: "rgba(255, 255, 255, 0.80)",
        "&.Mui-focused": {
          color: "rgba(255, 255, 255, 0.80)",
        },
      },
      "& .MuiInputBase-input": {
        color: "#FFFFFF",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "rgba(255, 255, 255, 0.80)",
        },
        "&:hover fieldset": {
          borderColor: "rgba(255, 255, 255, 0.80)",
        },
        "&.Mui-focused fieldset": {
          borderColor: "rgba(255, 255, 255, 0.80) ",
        },
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiInputLabel-root": {
        color: "rgba(255, 255, 255, 0.80) ",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgba(255, 255, 255, 0.80) ",
      },
    };
  };

  const getAllLanguage = async () => {
    try {
      const res = await getVoiceAgentLanguageForCallingAgent();
      const allLanguage = await res.json();
      if (allLanguage.status) {
        // console.log("allLanguageForVoiceAgent", allLanguage?.data)
        setVoiceAgentsAllLanguage(allLanguage?.data);
      } else {
        setToastopen(true);
        setContent(allLanguage?.message);
        setIconType("error");
      }
    } catch (error) {
      console.error("API Error:", error);
      setToastopen(true);
      setContent(error?.message);
      setIconType("error");
    }
  };

  const getAllPersona = async () => {
    try {
      const res = await getVoiceAgentPersonaForCallingAgent();
      const allPersona = await res.json();
      if (allPersona.status) {
        // console.log("allPersonaForVoiceAgent", allPersona?.data)
        setVoiceAgentsAllPersona(allPersona?.data);
      } else {
        setToastopen(true);
        setContent(allPersona?.message);
        setIconType("error");
      }
    } catch (error) {
      console.error("API Error:", error);
      setToastopen(true);
      setContent(error?.message);
      setIconType("error");
    }
  };

  const getAllPhoneNumber = async () => {
    try {
      const res = await getVoiceAgentPhoneNumberForCallingAgent();
      const allPhoneNumber = await res.json();
      // console.log("allPhoneNumberForVoiceAgent", allPhoneNumber)
      if (allPhoneNumber?.status) {
        setVoiceAgentsAllPhoneNumber(allPhoneNumber?.data);
      } else {
        setToastopen(true);
        setContent(allPhoneNumber?.message);
        setIconType("error");
      }
    } catch (error) {
      console.error("API Error:", error);
      setToastopen(true);
      setContent(error?.message);
      setIconType("error");
    }
  };

  const getAllAIAgent = async () => {
    try {
      const res = await getLLMAgentForCalligAgent("");
      const LlmData = await res?.json();
      if (LlmData?.status) {
        // console.log("LlmData",LlmData?.data)
        setVoiceAgentAllAIAgent(LlmData?.data?.data);
      } else {
        setToastopen(true);
        setContent(LlmData?.message);
        setIconType("error");
      }
    } catch (error) {
      console.log(error);
      setToastopen(true);
      setContent(error?.message);
      setIconType("error");
    }
  };

  useEffect(() => {
    if (!voiceAgentsAllLanguage) {
      getAllLanguage();
    }
    if (!voiceAgentsAllPersona) {
      getAllPersona();
    }
    if (!voiceAgentsAllPhoneNumber) {
      getAllPhoneNumber();
    }
  }, []);

  useEffect(()=>{
    getAllAIAgent();
  },[])

  const handleAddVoiceAgent = async () => {
    setLoading(true)
    try {
      const jsonResponse = await AddVoiceAgentForCallingAgent(addVoiceAgent);
      const response = await jsonResponse.json();
      if (response?.status) {
        setopenAddVoiceAgentModal(false);
        HandleCloseButtonClick();
        setToastopen(true);
        setContent(response?.message);
        setIconType("success");
        await fetchData();
      } else {
        setToastopen(true);
        setContent(response?.message);
        setIconType("error");
      }
    } catch (error) {
      console.error("API Error:", error);
      setToastopen(true);
      setContent(error?.message);
      setIconType("error");
    }finally{
      setLoading(false)
    }
  };

  // console.log("match", activeUserObject)
  // console.log("addVoiceAgent", addVoiceAgent)

  const handleUpdateVoiceAgent = async () => {
    setLoading(true)
    try {
      const jsonResponse = await UpdateVoiceAgentbyIdForCallingAgent(
        activeUserObject?.id,
        addVoiceAgent
      );
      const Response = await jsonResponse.json();
      if (Response?.status) {
        setMoreActionOption(false);
        setopenAddVoiceAgentModal(false);
        HandleCloseButtonClick();
        setToastopen(true);
        setContent(Response?.message);
        setIconType("success");
        await fetchData();
      } else {
        setToastopen(true);
        setContent(Response?.message);
        setIconType("error");
      }
    } catch (error) {
      console.error("API Error:", error);
      setToastopen(true);
      setContent(error?.message);
      setIconType("error");
    }finally{
      setLoading(false)
    }
  };

  const handleToastClose = () => {
    setToastopen(false);
  };

    const handleVoiceSelect = (voice) => {
     if (playingVoice === voice?.voice_id) {
       if (audioElement.current) {
         audioElement.current.pause();
         audioElement.current.currentTime = 0; // Reset audio to start
         audioElement.current = null;
       }
       setPlayingVoice(null);
     } else {
       if (audioElement.current) {
         audioElement.current.pause();
         audioElement.current.currentTime = 0; // Reset audio to start
         audioElement.current = null;
       }
       const newAudioElement = new Audio(voice?.sample_url);
 
       // When audio ends, reset the playingVoice state
       newAudioElement.onended = () => {
         setPlayingVoice(null);
       };
 
       newAudioElement
         .play()
         .catch((error) => console.error("Playback error:", error));
 
       setPlayingVoice(voice?.voice_id);
       audioElement.current = newAudioElement;
     }
   };

   const stopAudio = () => {
  if (audioElement.current) {
    audioElement.current.pause();
    audioElement.current.currentTime = 0;
    audioElement.current.src = "";
    audioElement.current = null;
  }
  setPlayingVoice(null);
};


  return (
    <div>
      <Modal
        open={openAddVoiceAgentModal}
        onClose={HandleCloseButtonClick}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "16px",
        }}
      >
        <Box
          sx={{
            width: "640px",
            backgroundColor: "background.paper",
            boxShadow: 24,
            display: "flex",
            flexDirection: "column",
            bgcolor: theme === "dark" ? settingsModal_bg_color_dm : "",
            borderRadius: "8px",
            maxHeight: "92vh",
          }}
        >
          <Typography
            id="audio-settings-title"
            variant="h6"
            component="h2"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              height: "68px",
              // mb: 2,
              borderBottom: `1px solid ${
                theme === "dark" ? "rgba(255, 255, 255, 0.10)" : ""
              }`,
              padding: "20px",
              font: "Inter",
            }}
            style={{
              fontSize: "20px",
              fontWeight: "600",
              color: theme === "dark" ? "#FFFFFF" : "",
            }}
          >
            Add voice agent
            <IconButton
              aria-label="close"
              onClick={HandleCloseButtonClick}
              sx={{
                // color: (theme) => theme.palette.grey[500],
                color: "#FFFFFF",
              }}
            >
              <CloseIcon />
            </IconButton>
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              padding: "40px 40px 0px 40px",
              overflowY: "auto",
            }}
          >
            <Box
            // sx={{ overflow : ((isHeightUnder700px && window ===1) || (isHeightUnder600px) && window===0) ? "scroll" : "",height: ((isHeightUnder700px && window ===1) || (isHeightUnder700px) && window===0) ? "330px" : "", }}
            >
              <Box sx={{ marginBottom: 5 }}>
                <TextField
                  type="Label"
                  onChange={(e) => {
                    setAddVoiceAgent((prev) => ({
                      ...prev,
                      label: e.target.value,
                    }));
                  }}
                  value={addVoiceAgent?.label}
                  id="outlined-basic"
                  label="Label"
                  placeholder="Webcall on corporate site, Phone for customer support, etc."
                  variant="outlined"
                  sx={customTextFieldStyles(false)}
                  // sx={{...customTextFieldStyles(false),mt:5}}
                  style={{
                    width: "100%",
                    maxWidth: "100%",
                    height: "56px",
                    color: "#FFFFFF",
                    backgroundColor: "#232746",
                    borderRadius: "16px",
                    boxShadow: "0px 0px 80px 0px rgba(0, 0, 0, 0.40)",
                    placeholderfontsize: "16px",
                  }}
                />
              </Box>

              <Box sx={{ minWidth: "100%", marginBottom: 3 }}>
                <FormControl fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    sx={{
                      color: "rgba(255, 255, 255, 0.80)",
                      "&.Mui-focused": {
                        color: "rgba(255, 255, 255, 0.80) !important",
                      },
                    }}
                  >
                    Agent language
                  </InputLabel>
                  <Select
                    sx={{
                      ...customTextFieldStylesforDropDownButton,
                      "& .MuiSelect-select": {
                        backgroundColor: "#282D51",
                      },
                      ".MuiSelect-icon": {
                        color: "#ffffff",
                      },
                    }}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={addVoiceAgent.language_id}
                    label="Agent language"
                    onChange={(e) => {
                      setAddVoiceAgent((prev) => ({
                        ...prev,
                        language_id: e.target.value,
                      }));
                    }}
                    placeholder="Choose agent language"
                  >
                    {voiceAgentsAllLanguage?.map((element, index) => {
                      return (
                        <MenuItem
                          key={element?.id}
                          sx={{
                            bgcolor: "#2F355F",
                            marginTop: "-8px",
                            marginBottom: "-8px",
                            color: "white",
                            height: "56px",
                            "&:hover": {
                              bgcolor: "#393F69",
                            },
                            "&.Mui-selected": {
                              bgcolor: "#393F69 !important", // Ensure selected background color stays
                            },
                          }}
                          value={element?.id}
                        >
                          {element?.label}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                <FormHelperText
                  sx={{
                    color:
                      "var(--M3-sys-dark-on-surface-variant, var(--Schemes-Outline-Variant, #CAC4D0))",
                    fontFamily: "Inter",
                    fontSize: "12px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "16px",
                    margin: "4px 0px 0px 16px",
                    alignSelf: "start",
                  }}
                >
                  {`language of the agent.`}
                </FormHelperText>
              </Box>

              <Box sx={{ minWidth: "100%", marginBottom: 3 }}>
                <FormControl fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    sx={{
                      color: "rgba(255, 255, 255, 0.80)",
                      "&.Mui-focused": {
                        color: "rgba(255, 255, 255, 0.80) !important",
                      },
                    }}
                  >
                    Agent persona
                  </InputLabel>
                  <Select onClose={() => {stopAudio();}}
                    renderValue={(selectedId) => {
                          const selected = voiceAgentsAllPersona?.find((el) => el.id === selectedId);
                          return selected?.name || "";
                        }}
                    sx={{
                      ...customTextFieldStylesforDropDownButton,
                      "& .MuiSelect-select": {
                        backgroundColor: "#282D51",
                      },
                      ".MuiSelect-icon": {
                        color: "#ffffff",
                      },
                    }}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={addVoiceAgent?.voice_persona_id}
                    label="Agent persona"
                    onChange={(e) => {
                      setAddVoiceAgent((prev) => ({
                        ...prev,
                        voice_persona_id: e.target.value,
                      }));
                    }}
                  >
                    {voiceAgentsAllPersona?.map((element, index) => {
                      return (
                        <MenuItem
                          key={element?.id}
                          sx={{
                            bgcolor: "#2F355F",
                            marginTop: "-8px",
                            marginBottom: "-8px",
                            color: "white",
                            height: "56px",
                            "&:hover": {
                              bgcolor: "#393F69",
                            },
                            "&.Mui-selected": {
                              bgcolor: "#393F69 !important", // Ensure selected background color stays
                            },
                          }}
                          value={element?.id}
                        >
                          <Box sx={{display:"flex", flexDirection:"row", columnGap:"20px", alignItems:"center"}}>
                            <Tooltip
                                                     componentsProps={{
                                                       tooltip: {
                                                         sx: {
                                                           bgcolor: "#E6E0E9",
                                                           color: "#17182C",
                                                           fontFamily: "Inter",
                                                           fontSize: "12px",
                                                           fontWeight: 500,
                                                           padding: "4px 8px 4px 8px",
                                                           borderRadius: "4px",
                                                           textAlign: "center",
                                                         },
                                                       },
                                                     }}
                                                     title={
                                                       playingVoice === element.voice_id
                                                         ? `Stop voice`
                                                         : `Preview voice`
                                                     }
                                                   >
                                                     <IconButton
                                                       disabled={!element?.sample_url}
                                                       onClick={(e) => {
                                                         handleVoiceSelect(element);
                                                         e.stopPropagation();
                                                       }}
                                                       sx={{
                                                         color:
                                                           playingVoice === element?.voice_id
                                                             ? "rgba(23, 26, 45, 1)"
                                                             : "rgba(23, 26, 45, 1)",
                                                         backgroundColor:
                                                           playingVoice === element?.voice_id
                                                             ? "white"
                                                             : "white",
                                                         transition:
                                                           "background-color 0.3s ease, transform 0.2s ease",
                                                         "&:hover": {
                                                           backgroundColor: "white",
                                                         },
                                                         "&:disabled": {
                                                           color: "rgba(230, 224, 233, 1)",
                                                           bgcolor: "rgba(230, 224, 233, 0.12)",
                                                         },
                                                         width: "30px",
                                                         height: "30px",
                                                         padding: "12px",
                                                         borderRadius: "50%",
                                                       }}
                                                     >
                                                       {playingVoice === element?.voice_id ? (
                                                         <PauseIcon sx={{}} />
                                                       ) : (
                                                         <PlayArrowIcon sx={{}} />
                                                       )}
                                                     </IconButton>
                            </Tooltip>
                          <Box>
                          {element?.name}
                          </Box>
                          </Box>
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                <FormHelperText
                  sx={{
                    color:
                      "var(--M3-sys-dark-on-surface-variant, var(--Schemes-Outline-Variant, #CAC4D0))",
                    fontFamily: "Inter",
                    fontSize: "12px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "16px",
                    margin: "4px 0px 0px 16px",
                    alignSelf: "start",
                  }}
                >
                  {`Voice of the agent`}
                </FormHelperText>
              </Box>

              <Box sx={{ minWidth: "100%", marginBottom: 3 }}>
                <FormControl fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    sx={{
                      color: "rgba(255, 255, 255, 0.80)",
                      "&.Mui-focused": {
                        color: "rgba(255, 255, 255, 0.80) !important",
                      },
                    }}
                  >
                    AI model
                  </InputLabel>
                  <Select
                    sx={{
                      ...customTextFieldStylesforDropDownButton,
                      "& .MuiSelect-select": {
                        backgroundColor: "#282D51",
                      },
                      ".MuiSelect-icon": {
                        color: "#ffffff",
                      },
                    }}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={addVoiceAgent?.ai_model_id}
                    label="AI model"
                    onChange={(e) => {
                      setAddVoiceAgent((prev) => ({
                        ...prev,
                        ai_model_id: e.target.value,
                      }));
                    }}
                  >
                    {voiceAgentAllAIAgent?.map((element, index) => {
                      return (
                        <MenuItem
                          key={element?.id}
                          sx={{
                            bgcolor: "#2F355F",
                            marginTop: "-8px",
                            marginBottom: "-8px",
                            color: "white",
                            height: "56px",
                            "&:hover": {
                              bgcolor: "#393F69",
                            },
                            "&.Mui-selected": {
                              bgcolor: "#393F69 !important", // Ensure selected background color stays
                            },
                          }}
                          value={element?.id}
                        >
                          {element?.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                <FormHelperText
                  sx={{
                    color:
                      "var(--M3-sys-dark-on-surface-variant, var(--Schemes-Outline-Variant, #CAC4D0))",
                    fontFamily: "Inter",
                    fontSize: "12px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "16px",
                    margin: "4px 0px 0px 16px",
                    alignSelf: "start",
                  }}
                >
                  {`AI model to use for the agent`}
                </FormHelperText>
              </Box>

              {/* <Box sx={{ minWidth: "100%", marginBottom: 3 }}>
                <FormControl fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    sx={{
                      color: "rgba(255, 255, 255, 0.80)",
                      "&.Mui-focused": {
                        color: "rgba(255, 255, 255, 0.80) !important",
                      },
                    }}
                  >
                    Tools (optional)
                  </InputLabel>
                  <Select
                    sx={{
                      ...customTextFieldStylesforDropDownButton,
                      "& .MuiSelect-select": {
                        backgroundColor: "#282D51",
                      },
                      ".MuiSelect-icon": {
                        color: "#ffffff",
                      },
                    }}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    //   value={checkforupdates}
                    label="Tools (optional)"
                    //   onChange={handleCheckForUpdateSelect}
                  >
                    <MenuItem
                      sx={{
                        bgcolor: "#2F355F",
                        marginTop: "-8px",
                        marginBottom: "-8px",
                        color: "white",
                        height: "56px",
                        "&:hover": {
                          bgcolor: "#393F69",
                        },
                        "&.Mui-selected": {
                          bgcolor: "#282D51 !important", // Ensure selected background color stays
                        },
                      }}
                      value={120}
                    >
                      No Type
                    </MenuItem>
                    <MenuItem
                      sx={{
                        bgcolor: "#2F355F",
                        marginTop: "-8px",
                        marginBottom: "-8px",
                        color: "white",
                        height: "56px",
                        "&:hover": {
                          bgcolor: "#393F69",
                        },
                        "&.Mui-selected": {
                          bgcolor: "#393F69 !important", // Ensure selected background color stays
                        },
                      }}
                      value={1440}
                    >
                      1 Type
                    </MenuItem>
                    <MenuItem
                      sx={{
                        bgcolor: "#2F355F",
                        marginTop: "-8px",
                        marginBottom: "-8px",
                        color: "white",
                        height: "56px",
                        "&:hover": {
                          bgcolor: "#393F69",
                        },
                        "&.Mui-selected": {
                          bgcolor: "#282D51 !important", // Ensure selected background color stays
                        },
                      }}
                      value={10080}
                    >
                      2 Type
                    </MenuItem>
                    <MenuItem
                      sx={{
                        bgcolor: "#2F355F",
                        marginTop: "-8px",
                        marginBottom: "-8px",
                        color: "white",
                        height: "56px",
                        "&:hover": {
                          bgcolor: "#393F69",
                        },
                        "&.Mui-selected": {
                          bgcolor: "#393F69 !important", // Ensure selected background color stays
                        },
                      }}
                      value={43200}
                    >
                      3 Type
                    </MenuItem>
                  </Select>
                </FormControl>
              </Box> */}

              <Box sx={{ marginBottom: 3 }}>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontStyle: "normal",
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "19.6px",
                    letterSpacing: "0.1px",
                    marginBottom: "20px",
                  }}
                >
                  Voice type
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    columnGap: "12px",
                  }}
                >
                  <Box
                    onClick={(e) => {
                      setAddVoiceAgent((prev) => ({
                        ...prev,
                        type: "web_call",
                      }));
                    }}
                    value={"web_call"}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      columnGap: "10px",
                      height: "36px",
                      padding: "8px 12px",
                      borderRadius: "8px",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor:
                        addVoiceAgent.type == "web_call"
                          ? "#282D51"
                          : "#1F233E",
                      border:
                        addVoiceAgent.type == "web_call"
                          ? "1px solid rgba(255, 255, 255, 0.30)"
                          : "1px solid rgba(255, 255, 255, 0.10)",
                      cursor: "pointer",
                    }}
                  >
                    Web Call
                  </Box>
                  <Box
                    onClick={(e) => {
                      setAddVoiceAgent((prev) => ({
                        ...prev,
                        type: "phone_call",
                      }));
                    }}
                    value={"phone_call"}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      columnGap: "10px",
                      height: "36px",
                      padding: "8px 12px",
                      borderRadius: "8px",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor:
                        addVoiceAgent.type == "phone_call"
                          ? "#282D51"
                          : "#1F233E",
                      border:
                        addVoiceAgent.type == "phone_call"
                          ? "1px solid rgba(255, 255, 255, 0.30)"
                          : "1px solid rgba(255, 255, 255, 0.10)",
                      cursor: "pointer",
                    }}
                  >
                    Phone Call
                  </Box>
                </Box>
              </Box>

              {
                addVoiceAgent?.type == "phone_call" ?
              <Box sx={{ minWidth: "100%", marginBottom: 3 }}>
                <FormControl fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    sx={{
                      color: "rgba(255, 255, 255, 0.80)",
                      "&.Mui-focused": {
                        color: "rgba(255, 255, 255, 0.80) !important",
                      },
                    }}
                  >
                    Phone number
                  </InputLabel>
                  <Select
                    disabled={addVoiceAgent.type == "web_call"}
                    sx={{
                      ...customTextFieldStylesforDropDownButton,
                      "& .MuiSelect-select": {
                        backgroundColor: "#282D51",
                      },
                      ".MuiSelect-icon": {
                        color: "#ffffff",
                      },
                    }}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={addVoiceAgent?.phone_number_id}
                    label="Phone number"
                    onChange={(e) => {
                      setAddVoiceAgent((prev) => ({
                        ...prev,
                        phone_number_id: e.target.value,
                      }));
                    }}
                  >
                    {voiceAgentsAllPhoneNumber?.map((element, index) => {
                      return (
                        <MenuItem
                          key={element?.id}
                          sx={{
                            bgcolor: "#2F355F",
                            marginTop: "-8px",
                            marginBottom: "-8px",
                            color: "white",
                            height: "56px",
                            "&:hover": {
                              bgcolor: "#393F69",
                            },
                            "&.Mui-selected": {
                              bgcolor: "#393F69 !important", // Ensure selected background color stays
                            },
                          }}
                          value={element?.id}
                        >
                          {element?.number}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                <FormHelperText
                  sx={{
                    color:
                      "var(--M3-sys-dark-on-surface-variant, var(--Schemes-Outline-Variant, #CAC4D0))",
                    fontFamily: "Inter",
                    fontSize: "12px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "16px",
                    margin: "4px 0px 0px 16px",
                    alignSelf: "start",
                  }}
                >
                  {`Assign phone number to the agent`}
                </FormHelperText>
              </Box> 
              : null
              }

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  columnGap: "12px",
                }}
              >
                <FormControlLabel
                  control={
                    <ToggleSwitch
                      sx={{ transform: "scale(0.8)" }}
                      checked={addVoiceAgent?.auto_detect_context}
                    />
                  }
                  label=""
                  labelPlacement=""
                  sx={{
                    whiteSpace: "nowrap",
                    margin: 0, // Removes default margin
                    maxWidth: "100%", // Ensures it doesn't exceed the parent's width
                    display: "flex",
                    alignItems: "center",
                  }}
                />
                <Typography
                  id="audio-settings-title"
                  variant="h6"
                  component="h2"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    font: "Inter",
                  }}
                  style={{
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "20px",
                    color: theme === "dark" ? "#FFFFFF" : "",
                  }}
                >
                  Automatically detect user context from inbound phone number
                </Typography>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              // boxShadow: "0px -4px 8px 0px rgba(0, 0, 0, 0.12)",
              p: 5,
            }}
          >
            <Button disabled={loading}
              variant="contained"
              onClick={
                activeUserObject
                  ? () => handleUpdateVoiceAgent()
                  : () => handleAddVoiceAgent()
              }
              sx={{
                backgroundColor:
                  theme === "dark" ? button_bg_color_for_New_Project : "",
                "&:hover": {
                  backgroundColor: "#FFD9AA",
                },
                color: "#17182C",
                fontSize: "16px",
                fontWeight: 600,
                textTransform: "none",
                fontFamily: "Inter, sans-serif",
                width: "100%",
                '&:disabled': {
                     backgroundColor: button_bg_color_for_New_Project
                 }
              }}
            >
              { loading ?  <CircularProgress sx={{width:"16px", height:"16px", color:"#17182C"}}/>  : activeUserObject ? "Update voice agent" : "Add voice agent"}
            </Button>
          </Box>
        </Box>
      </Modal>
      <CommonToast
        open={toastopen}
        onClose={handleToastClose}
        content={content}
        iconType={iconType}
        bgColor={"#282D51"}
      />
    </div>
  );
};

export default ModalForVoiceAgent;
